import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'bar-graph',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    :host {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-end;
      padding: 0px 2px;
      gap: 4px;
    }

    .bar {
      position: relative;
      flex-grow: 1;
      background: #dfdfdf;
      border-radius: 2px 2px 0 0;
      overflow: hidden;
    }

    .bar::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: var(--fg-height, 0%);
      background: #66d68d;
      border-radius: 2px 2px 0 0;
    }
  `],
  template: `
    <div
      *ngFor="let pair of barHeights"
      class="bar"
      [style.height]="pair.bg + '%'"
      [style.--fg-height]="pair.fg + '%'"
    ></div>
  `
})
export class BarGraphComponent {
  @Input() data: { value1: number; value2: number }[] = [];

  barHeights: { fg: number; bg: number }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.updateBars();
    }
  }

  updateBars(): void {
    const max = Math.max(...this.data.map(({ value1, value2 }) => Math.max(value1 || 0, value2 || 0, 1)));
    this.barHeights = this.data.map(({ value1, value2 }) => {
      value1 = Math.max(value1 || 0, value2 || 0);
      const bg = (value1 / max) * 100; // Scale to percentage
      const fg = value2 ? (value2 / value1) * 100 : 0; // Scale fg based on value1

      return {
        bg: Math.min(bg, 100),
        fg: Math.min(fg, 100),
      };
    });
  }
}
